// extracted by mini-css-extract-plugin
export default {"tabsContainer":"FilesModule_tabsContainer__4B15C","tab":"FilesModule_tab__Qy-Cq","active":"FilesModule_active__M3-zK","container":"FilesModule_container__bkgkr"};